import WebsocketManager from '@/js/websocketManager.js'
import Emitter from 'event-emitter'

const STATES = ["scissors", "rock", "paper"]
const NAMES = ["Yéléna", "Mathias", "Gautier", "Victor", "Alice", "Camille", "Marylin", "Annaelle", "Marie", "Sylvain", "Alex", "Dorian", "Ben", "Gaspard", "Valentin", "Guillaume", "Pierre", "Anais", "Charlene", "Mathieu", "Loic", "Grégoire", "Jean-Baptiste", "Justin", "Prachi", "Raphael", "Julie", "Micke", "Carlos", "Mathilde", "Patrick", "JC"]
//const NAMES = ["Alice"]


class GameAI {
    constructor(){
        this.state = "none"
        
        this._emitter = {}
        Emitter(this._emitter)
        this.on = this._emitter.on.bind(this._emitter)
        this.off = this._emitter.off.bind(this._emitter)

        this.init()
    }

    init(){

        this.name = this.getRandomName()
        WebsocketManager.aiConnect(this.name)
        this.interval = setInterval(() => {
            this.setState()
            WebsocketManager._emitter.emit("tracking", this.state)
        }, 1000);
        this.setState()

        setTimeout(() => {
            WebsocketManager.onReady([WebsocketManager.name, this.name])
        }, 1000);

    }

    getRandomName(){
        return NAMES[Math.floor(Math.random() * NAMES.length)]
    }

    kill(){
        clearInterval(this.interval)
    }

    setState(){
        this.state = STATES[Math.floor(Math.random() * STATES.length)]
        this._emitter.emit("tracking", this.state)
    }

}

export default GameAI